// extracted by mini-css-extract-plugin
export default {"container":"ProfileLayout_container__Ii51-","body":"ProfileLayout_body__MvNIq","ocean_background":"ProfileLayout_ocean_background__oAtnH","ASide":"ProfileLayout_ASide__fZslF"};